import { Page } from "src/components/FlowLayout";
import { PageStateConverter } from "src/hooks/usePageState";
import { MortgageInformation } from "src/types/Applicant";

import { enums, isTruthy } from "@fraction/shared";

import { MortgageBalanceAndLender, MortgagePayments, MortgageRateAndType } from "./pages";

export type MortgageInformationSectionArguments = PageStateConverter<
  MortgageInformation,
  "mortgageRateAndType" | "mortgageBalanceAndLender" | "mortgagePayments"
> & {
  showBalanceAndLenderPage?: boolean;
  propertyAddress?: string;
  index?: number;
  isSubpage?: boolean;
};

const MortgageInformationPages = ({
  mortgageRateAndType,
  mortgageBalanceAndLender,
  mortgagePayments,
  propertyAddress,
  showBalanceAndLenderPage = true,
  index = 0,
  isSubpage,
}: MortgageInformationSectionArguments): Page[] =>
  [
    showBalanceAndLenderPage && {
      name: `${propertyAddress || "_"}${index}mortgageBalanceAndLender`,
      component: <MortgageBalanceAndLender propertyAddress={propertyAddress} {...mortgageBalanceAndLender} />,
      pageNeedsToBeFilled:
        !mortgageBalanceAndLender?.value?.lenderName || !mortgageBalanceAndLender?.value?.amount,
    },
    {
      name: `${propertyAddress}${index}mortgageRateAndType`,
      component: (
        <MortgageRateAndType
          lenderName={mortgageBalanceAndLender?.value?.lenderName || ""}
          propertyAddress={propertyAddress}
          isSubpage={isSubpage}
          {...mortgageRateAndType}
        />
      ),
      pageNeedsToBeFilled:
        !mortgageRateAndType?.value?.rateType ||
        !mortgageRateAndType?.value?.currentRate ||
        !mortgageRateAndType?.value?.mortgageType,
    },
    mortgageRateAndType?.value?.mortgageType !== enums.DebtType.REVERSE_MORTGAGE && {
      name: `${propertyAddress}${index}mortgagePayments`,
      component: (
        <MortgagePayments
          mortgageType={mortgageRateAndType?.value?.mortgageType}
          lenderName={mortgageBalanceAndLender?.value?.lenderName || ""}
          propertyAddress={propertyAddress}
          isSubpage={isSubpage}
          {...mortgagePayments}
        />
      ),
      pageNeedsToBeFilled: !mortgagePayments?.value?.paymentAmount || !mortgagePayments?.value?.frequency,
    },
  ].filter(isTruthy);

export default MortgageInformationPages;
